import { CityDropdownForTrip, CommonDatePicker, CommonInput, CommonModal, CustomSelect } from 'components';
import React, { useState, useEffect, useCallback } from 'react';
import './editTripModal.css'
import VehicleTypeModal from 'modals/VehicleTypeModal';
import { getLorryTypeList } from '_services/accountsServices/lrServices';
import { getAllDriver, getAllSupplier, handleKeyDown, updateTripApi } from '_services';
import StorageService from 'utils/StorageServices';
import toast from 'react-hot-toast';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';

const EditTripModal = (props) => {
  const { tripDetais, showEditTrip, closeModal, callApi } = props;

  // Destructure trip details with default values
  const {
    dispatch_date,
    due_date,
    end_date,
    vehicle_id,
    lorry_type_id,
    vehicle_type_id,
    vehicle_ownership,
    supplier_id,
    driver_id,
    route_name,
    start_kms,
    end_kms
  } = tripDetais || {};

  // Initialize form data with proper error handling for dates
  const [formData, setFormData] = useState({
    dispatch_date: dispatch_date ? new Date(dispatch_date) : new Date(),
    due_date: due_date ? new Date(due_date) : null,
    end_date: end_date ? new Date(end_date) : null,
    vehicle_id: vehicle_id || '',
    lorry_type_id: lorry_type_id || '',
    vehicle_type_id: vehicle_type_id || '',
    vehicle_ownership: vehicle_ownership || 1,
    supplier_id: supplier_id ? { ...supplier_id, label: supplier_id.name, value: supplier_id._id } : null,
    driver_id: driver_id ? { ...driver_id, label: driver_id.name, value: driver_id._id } : null,
    route_name: route_name || '',
    start_kms: start_kms || "",
    end_kms: end_kms || ""
  });

  console.log(dispatch_date,formData)

  const [formError, setFormError] = useState({});
  const [vehicleTypeshow, setVehicleTypeShow] = useState(false);
  const [vehicleTypeLabel, setVehicleTypeLabel] = useState({
    label: "",
    value: "",
  });
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [lorryType, setLorryType] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [driverList, setDriverList] = useState([]);

  // Helper function to safely format date to ISO string
  const formatDateToISO = useCallback((date) => {
    if (!date) return "";
    try {
      return new Date(date).toISOString();
    } catch (error) {
      console.error("Date formatting error:", error);
      return "";
    }
  }, []);

  // Helper function to extract vehicle type IDs from the stored value
  const extractVehicleTypeIds = useCallback((vehicleTypeValue) => {
    if (!vehicleTypeValue) return { vehicle_type_id: "", lorry_type_id: "" };

    try {
      const parts = vehicleTypeValue.split('_');
      return {
        lorry_type_id: parts[1] || "",
        vehicle_type_id: parts[1] || "",
      };
    } catch (error) {
      console.error("Vehicle type parsing error:", error);
      return { vehicle_type_id: "", lorry_type_id: "" };
    }
  }, []);

  // Helper function to safely extract value from select objects
  const extractSelectValue = useCallback((selectObj) => {
    return selectObj?.value || "";
  }, []);

  // Payload construction function
  const buildPayload = useCallback(() => {
    const basePayload = {
      company_id: StorageService?.getCompanyId() || "",
      trip_id: tripDetais?._id || "",
    };

    // Add date fields based on edit type
    switch (showEditTrip?.type) {
      case "Trip_start":
        basePayload.dispatch_date = formatDateToISO(formData.dispatch_date);
        break;
      case "Trip_due":
        basePayload.due_date = formatDateToISO(formData.due_date);
        break;
      case "Trip_end":
        basePayload.end_date = formatDateToISO(formData.end_date);
        break;
      case "vehicle_type":
        if (vehicleTypeLabel?.value) {

          basePayload.vehicle_type_id = formData?.vehicle_type_id?._id;
          basePayload.lorry_type_id = formData?.lorry_type_id?._id;
        }
        break;
      case "Trip_Supplier":
        if (formData.supplier_id?.value) {
          basePayload.supplier_id = formData.supplier_id.value;
        }
        break;
      case "Market_driver":
        if (formData.driver_id?.value) {
          basePayload.driver_id = formData.driver_id.value;
        }
        break;

      case "Own_driver":
        if (formData.driver_id?.value) {
          basePayload.driver_id = formData.driver_id.value;
          basePayload.is_existing_driver = 1
        }
        break;
      case "Start_km":
        basePayload.start_kms = formData.start_kms;
        break;
      case "End_km":
        basePayload.end_kms = formData.end_kms;
        break;
    }

    return basePayload;
  }, [formData, vehicleTypeLabel, showEditTrip?.type, tripDetais?._id, formatDateToISO, extractVehicleTypeIds]);

  // Form validation
  const validateForm = useCallback(() => {
    const errors = {};
    const { type } = showEditTrip || {};

    switch (type) {
      case "Trip_start":
        if (!formData.dispatch_date) {
          errors.dispatch_date = "Dispatch date is required";
        }
        break;
      case "Trip_due":
        if (!formData.due_date) {
          errors.due_date = "Due date is required";
        } else if (formData.dispatch_date && new Date(formData.due_date) < new Date(formData.dispatch_date)) {
          errors.due_date = "Due date cannot be before dispatch date";
        }
        break;
      case "Trip_end":
        if (!formData.end_date) {
          errors.end_date = "End date is required";
        } else if (formData.due_date && new Date(formData.end_date) < new Date(formData.due_date)) {
          errors.end_date = "End date cannot be before due date";
        }
        break;
      case "vehicle_type":
        if (!formData?.vehicle_type_id?._id) {
          errors.vehicle_type_id = "Vehicle type is required";
        }
        break;
      case "Trip_Supplier":
        if (!formData.supplier_id?.value) {
          errors.supplier_id = "Supplier is required";
        }
        break;
      case "Market_driver":
        if (!formData.driver_id?.value) {
          errors.driver_id = "Driver is required";
        }
        break;
      case "Own_driver":
        if (!formData.driver_id?.value) {
          errors.driver_id = "Driver is required";
        }
        break;
      case "Start_km":
        if (!formData.start_kms) {
          errors.start_id = "Start kms is required";
        }
        break;
      case "End_km":
        if (!formData.end_kms) {
          errors.end_kms = "End kms is required";
        }
        break;
    }

    setFormError(errors);
    return Object.keys(errors).length === 0;
  }, [formData, vehicleTypeLabel, showEditTrip?.type]);

  // Handle form submission
  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setSubmitLoading(true);
      const payload = buildPayload();

      const res = await updateTripApi(payload)
      if (res?.responseCode == 200) {

        setSubmitLoading(false)
        toast?.success(res?.responseMessage || "Update Successfully")
        callApi()
      }


      // Close modal on successful submission
      if (closeModal) {
        closeModal();
      }
    } catch (error) {
      console.error("Submission error:", error);
      // You might want to show an error message to the user here
    } finally {
      // setSubmitLoading(false);
    }
  };

  // Memoized API calls to prevent unnecessary re-renders
  const getDataLorryTypeList = useCallback(async () => {
    try {
      // setLoading(true);
      const res = await getLorryTypeList();
      setLorryType(res.data?.lorry_type || []);
    } catch (error) {
      console.error('Error fetching lorry types:', error);
      setLorryType([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const getSupplierList = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getAllSupplier({
        company_id: StorageService.getCompanyId(),
        offset: 1,
        limit: 2000
      });

      if (res?.responseCode === 200) {
        const supplierData = res?.data?.supplier_list?.map((item) => ({
          label: item.name,
          value: item._id,
        })) || [];
        setSupplierList(supplierData);
      }
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      setSupplierList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const getDriverList = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getAllDriver({
        company_id: StorageService.getCompanyId(),
        offset: 1,
        limit: 2000,
      });

      if (res?.responseCode === 200) {
        const driverData = res.data?.driver_list?.map((i) => ({
          ...i,
          label: i.name,
          value: i._id,
        })) || [];
        setDriverList(driverData);
      }
    } catch (error) {
      console.error('Error fetching drivers:', error);
      setDriverList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Effect to load data based on edit type
  useEffect(() => {
    if (!showEditTrip?.type) return;

    switch (showEditTrip.type) {
      case "vehicle_type":
        getDataLorryTypeList();
        break;
      case "Trip_Supplier":
        if (vehicle_ownership === 2) {
          // getSupplierList();
        }
        break;
      case "Market_driver":

        // getDriverList();

        break;
      case "Own_driver":

        // getDriverList();

        break;
      default:
        break;
    }
  }, [showEditTrip?.type, vehicle_ownership, getDataLorryTypeList, getSupplierList, getDriverList]);

  // Improved onChange handler with better type checking
  const handleOnChange = useCallback((field, value) => {
    setFormData(prevData => {
      const newData = { ...prevData };

      // Handle special field types
      if (['driver_id', 'supplier_id'].includes(field) && value?.value) {
        newData[field] = { label: value.label, value: value.value };
      } else if (field === 'route_name' && value?.label) {
        newData[field] = value.label;
      } else {
        newData[field] = value;
      }

      // Auto-calculate due date when dispatch date changes
      if (field === 'dispatch_date' && value) {
        const dispatchDate = new Date(value);
        const dueDate = new Date(dispatchDate);
        dueDate.setDate(dispatchDate.getDate() + 2);
        newData['due_date'] = dueDate;
      }

      return newData;
    });

    // Clear field-specific errors
    setFormError(prevErrors => {
      const newErrors = { ...prevErrors };
      delete newErrors[field];
      return newErrors;
    });
  }, []);

  const callBackVehicleType = useCallback((value) => {

    if (value?.activeTab?.lorry_type && value?.tyre?.label) {
      setVehicleTypeLabel({
        label: `${value.activeTab.lorry_type} > ${value.tyre.label}`,
        value: `${value.activeTab.lorry_type}_${value.tyre.label}`,
      });

      setFormData((pre) => ({
        ...pre,
        lorry_type_id: { lorry_type: value?.activeTab?.lorry_type, _id: value?.activeTab?._id },
        vehicle_type_id: { name: value?.tyre?.label, _id: value?.tyre?.value },
      }))
    }
    setVehicleTypeShow(false);
  }, []);

  // Vehicle type modal props
  const vehicleTypeProps = {
    isOpen: vehicleTypeshow,
    closeModal: () => setVehicleTypeShow(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Vehicle Type",
    submitTitle: "Save",
    isLoadding: loading,
    disabled: loading,
    lorryType: lorryType,
    callBackVehicleType: callBackVehicleType,
  };

  // Get current vehicle type display value
  const getCurrentVehicleType = useCallback(() => {
    if (vehicleTypeLabel?.label) {
      return vehicleTypeLabel;
    }
    if (vehicle_type_id?.name && lorry_type_id?.lorry_type) {
      return {
        label: `${lorry_type_id.lorry_type} > ${vehicle_type_id.name}`,
        value: `${lorry_type_id.lorry_type}_${vehicle_type_id._id}`
      };
    }
    return null;
  }, [vehicleTypeLabel, vehicle_type_id, lorry_type_id]);

  // Get filtered driver list based on vehicle ownership
  const getFilteredDrivers = useCallback(() => {
    return driverList.filter((driver) =>
      vehicle_ownership === 2 ? driver?.driver_type === 2 : driver?.driver_type === 1
    );
  }, [driverList, vehicle_ownership]);

  const fetchSupplier = async (search, page, limit) => {
    // if (loading) return { items: [], total: 0 };

    // setLoading(true);

    try {
      const res = await getAllSupplier({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        firm_id: tripDetais?.vehicle_id?.vehicle_ownership == 2 ? tripDetais?.firm_id?._id : ""

      });

      if (res?.responseCode === 200) {
        // setLoading(false);
        const list = await res?.data?.supplier_list
          .map((i) => ({
            ...i,
            name: i?.name,
            label: i?.name,
            value: i?._id
          }))

        return {
          items: list,
          total: res?.data?.total_record,
        };
      } else {
        // setLoading(false);
        toast.error(res?.responseMessage);
      }

    } catch (error) {
      toast.error("Error fetching drivers");
      return { items: [], total: 0 };
    } finally {
      // setLoading(false);
    }
  };

  const fetchDriver = async (search, page, limit) => {
    // if (loading) return { items: [], total: 0 };

    // setLoading(true);
    console.log(tripDetais)

    try {
      const res = await getAllDriver({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        driver_type: tripDetais?.vehicle_id?.vehicle_ownership == 2 ? 2 : [1, 3],
        firm_id: tripDetais?.interfirm != 0 ? tripDetais?.vehicle_firm?._id : tripDetais?.firm_id?._id
      });

      if (res?.responseCode === 200) {
        // setLoading(false);
        const list = await res?.data?.driver_list
          .map((i) => ({
            ...i,
            name: i?.name,
            label: i?.name,
            value: i?._id
          }))

        return {
          items: list,
          total: res?.data?.total_record,
        };
      } else {
        // setLoading(false);
        toast.error(res?.responseMessage);
      }

    } catch (error) {
      toast.error("Error fetching drivers");
      return { items: [], total: 0 };
    } finally {
      // setLoading(false);
    }
  };

  console.log("driver ", formData)
  const renderFormField = () => {
    const { type } = showEditTrip || {};

    switch (type) {
      case "Trip_start":
        return (
          <div className="_divForth">
            <CommonDatePicker
              name="dispatch_date"
              label="Date of Dispatch"
              startDate={formData.dispatch_date}
              setStartDate={(data) => handleOnChange("dispatch_date", data)}
              error={formError.dispatch_date}
              value={formData.dispatch_date}
              // maxDate={new Date(tripDetais?.end_date)}
              minDate={new Date()}
              disabled={tripDetais?.branch_id?.dispatch_date_time === 1}
            />
          </div>
        );

      case "Trip_due":
        return (
          <div className="_divForth">
            <CommonDatePicker
              name="due_date"
              label="Due Date"
              startDate={formData.due_date}
              setStartDate={(data) => handleOnChange("due_date", data)}
              error={formError.due_date}
              value={formData.due_date}
              // maxDate={new Date(tripDetais?.due_date)}
              minDate={new Date(tripDetais?.dispatch_date)}
            />
          </div>
        );

      case "Trip_end":
        return (
          <div className="_divForth">
            <CommonDatePicker
              name="end_date"
              label="End Date"
              startDate={formData.end_date}
              setStartDate={(data) => handleOnChange("end_date", data)}
              error={formError.end_date}
              value={formData.end_date}
              // maxDate={new Date(tripDetais?.end_date)}
              minDate={new Date(tripDetais?.dispatch_date)}

            />
          </div>
        );

      case "vehicle_type":
        return (
          <div className="_divForth" onClick={() => setVehicleTypeShow(true)}>
            <CustomSelect
              label="Vehicle Type"
              placeholder="Select Vehicle Type"
              options={[{ label: "Click to select", value: "select" }]}
              value={getCurrentVehicleType()}
              openList={false}
              error={formError.vehicle_type_id}
              disabled={loading}
            />
          </div>
        );

      case "Start_km":
        return (
          <div className="_divForth">
            <CommonInput
              type="text"
              label="Start Kms"
              name="start_kms"
              onChange={({ target: { name, value } }) =>
                handleOnChange(name, value)
              }
              value={formData?.start_kms}
              onKeyDown={handleKeyDown}
              error={formError.start_kms}
            />
          </div>
        );

      case "End_km":
        return (
          <div className="_divForth">
            <CommonInput
              type="text"
              label="End Kms"
              name="end_kms"
              onChange={({ target: { name, value } }) =>
                handleOnChange(name, value)
              }
              value={formData?.end_kms}
              onKeyDown={handleKeyDown}
              error={formError.end_kms}
            />
          </div>
        );

      case "Trip_Supplier":
        if (vehicle_ownership !== 2) return null;
        return (
          <div className="_divForth">
            {/* <CustomSelect
              label="Supplier Name"
              placeholder="Select Supplier"
              options={supplierList.length > 0 ? supplierList : [{ label: "No suppliers available", value: "", disabled: true }]}
              onSelect={(data) => handleOnChange("supplier_id", data)}
              value={formData.supplier_id}
              error={formError.supplier_id}
              disabled={loading || supplierList.length === 0}
            /> */}

            <CityDropdownForTrip
            //   key={`Suppler}`}
            //   label="Select Suppler"
            //   fetchData={fetchSupplier}
            //   selectedItem={{ name: formData?.supplier_id?.label, _id: formData?.supplier_id?.value }}
            //   onChange={(data) => handleOnChange("supplier_id", data)}
            //   error={!!formError.supplier_id}
            //   errorMessage={formError.supplier_id}
            //   pageSize={20}
            //   placeholder="Choose a Supplier..."
            //   // required={true}
            //   isAddButton={true}
            //   disabled={loading}
            // // addButtonAction={addNewSupplier}

             label={"Suppler"}
              placeholder="Select Suppler"
              fetchData={fetchSupplier}
              pageSize={20}
              onChange={(data) => handleOnChange("supplier_id", data)}
              selectedItem={formData?.supplier_id ? formData?.supplier_id : { label: "", value: "" }}
              disabled={loading}
              error={!!formError.supplier_id}
              errorMessage={formError.supplier_id}
            />
          </div>
        );

      case "Market_driver":
        // const filteredDrivers = getFilteredDrivers();
        return (
          <div className="_divForth">
            {/* <CustomSelect
              label="Driver"
              placeholder="Select Driver"
              options={filteredDrivers.length > 0 ? filteredDrivers : [{ label: "No drivers available", value: "", disabled: true }]}
              onSelect={(data) => handleOnChange("driver_id", data)}
              value={formData.driver_id}
              error={formError.driver_id}
              disabled={loading || filteredDrivers.length === 0}
            /> */}

            <CityDropdownForTrip
              label={"Driver"}
              placeholder="Select Driver"
              fetchData={fetchDriver}
              pageSize={20}
              onChange={(data) => handleOnChange("driver_id", data)}
              selectedItem={formData?.driver_id ? formData?.driver_id : { label: "", value: "" }}
              disabled={loading}
              error={!!formError.driver_id}
              errorMessage={formError.driver_id}
            />
          </div>


        );

      case "Own_driver":
        // const filteredOwnDrivers = getFilteredDrivers();
        return (
          <div className="_divForth">
            {/* <CustomSelect
              label="Driver"
              placeholder="Select Driver"
              options={filteredOwnDrivers.length > 0 ? filteredOwnDrivers : [{ label: "No drivers available", value: "", disabled: true }]}
              onSelect={(data) => handleOnChange("driver_id", data)}
              value={formData.driver_id}
              error={formError.driver_id}
              disabled={loading || filteredOwnDrivers.length === 0}
            /> */}
            <CityDropdownForTrip
              // key={`driver}`}
              // label="Select driver"
              // fetchData={fetchDriver}
              // selectedItem={{...formData?.driver_id, label: formData?.driver_id?.label, value: formData?.driver_id?.value }}
              // onChange={(data) => handleOnChange("driver_id", data)}
              // error={!!formError.driver_id}
              // errorMessage={formError.driver_id}
              // pageSize={20}
              // placeholder="Choose a driver..."
              // required={true}
              // isAddButton={true}
              // disabled={loading}
              // addButtonAction={addNewSupplier}


              label={"Driver"}
              placeholder="Select Driver"
              fetchData={fetchDriver}
              pageSize={20}
              onChange={(data) => handleOnChange("driver_id", data)}
              selectedItem={formData?.driver_id ? formData?.driver_id : { label: "", value: "" }}
              disabled={loading}
              error={!!formError.driver_id}
              errorMessage={formError.driver_id}
            />
          </div>
        );

      default:
        return null;
    }
  };

  const getModalTitle = () => {
  switch (showEditTrip?.type) {
    case "Trip_start":    return "Edit Start Date";
    case "Trip_due":      return "Edit Due Date";
    case "Trip_end":      return "Edit End Date";
    case "vehicle_type":  return "Edit Vehicle Type";
    case "Trip_Supplier": return "Edit Supplier";
    case "Market_driver": return "Edit Market Driver";
    case "Own_driver":    return "Edit Driver";
    case "Start_km":      return "Edit Start KMs";
    case "End_km":        return "Edit End KMs";
    default:              return "Edit Trip";
  }
};
  // Enhanced modal props with submit functionality
  const editTripProps = {
    ...props,
    modalTitle: getModalTitle(), 
    submitTitle: "Update Trip",
    onSubmit: handleSubmit,
    isLoadding: submitLoading,
    disabled: submitLoading || loading,
    footerPart: true,
    headerPart: true,
    isLoadding: submitLoading
  };

  return (
    <>
      <CommonModal {...editTripProps}>
        <div className='editTrip_body'>
          {renderFormField()}
          {(loading || submitLoading) && (
            <div className="loading-indicator" style={{ textAlign: 'center', padding: '10px' }}>
              {/* {submitLoading ? "Updating..." : "Loading..."} */}
            </div>
          )}
        </div>
      </CommonModal>

      {vehicleTypeshow && <VehicleTypeModal {...vehicleTypeProps} />}
    </>
  );
};

export default EditTripModal;